@for(donation of p2pDonations; track donation.id) {
    <div class="d-flex border-bottom mt-2 pb-2">
        <div class="d-flex w-100 align-items-center">
            <div class="col-6 name-container" style="word-wrap: break-word;">
                <span (click)="donorSelected(donation)" class="name-container__name cursor--pointer subtitle-1">{{donation.payer.name}}</span> <br>
                <span class="name-container__email grey-text">{{donation.payer.email}}</span>
            </div>
            <div class="col-2 p-0">
                <span class="subtitle-2--regular">{{getAmountDisplay(donation.amount)}}</span>
            </div>
            <div class="col-4 p-0 d-flex justify-content-end pr-3">
                <span class="subtitle-2--regular grey-text">{{getDate(donation.created)}}</span>
            </div>
        </div>
    </div>
}